module.exports = {
	"title": "CSS3 text-align-last",
	"description": "CSS property to describe how the last line of a block or a line right before a forced line break when `text-align` is `justify`.",
	"spec": "http://www.w3.org/TR/css3-text/#text-align-last-property",
	"status": "wd",
	"links": [
		{
			"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-align-last",
			"title": "MDN text-align-last"
		},
		{
			"url": "http://blogs.adobe.com/webplatform/2014/02/25/improving-your-sites-visual-details-css3-text-align-last/",
			"title": "Adobe Web Platform Article"
		}
	],
	"bugs": [],
	"categories": [
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "a #1",
			"7": "a #1",
			"8": "a #1",
			"9": "a #1",
			"10": "a #1",
			"11": "a #1",
			"5.5": "a #1"
		},
		"edge": {
			"12": "a",
			"13": "a",
			"14": "a"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y x",
			"28": "y x",
			"29": "y x",
			"30": "y x",
			"31": "y x",
			"32": "y x",
			"33": "y x",
			"34": "y x",
			"35": "y x",
			"36": "y x",
			"37": "y x",
			"38": "y x",
			"39": "y x",
			"40": "y x",
			"41": "y x",
			"42": "y x",
			"43": "y x",
			"44": "y x",
			"45": "y x",
			"46": "y x",
			"47": "y x",
			"48": "y x",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n d #2",
			"36": "n d #2",
			"37": "n d #2",
			"38": "n d #2",
			"39": "n d #2",
			"40": "n d #2",
			"41": "n d #2",
			"42": "n d #2",
			"43": "n d #2",
			"44": "n d #2",
			"45": "n d #2",
			"46": "n d #2",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"54": "y",
			"55": "y",
			"56": "y",
			"57": "y"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "n",
			"7.1": "n",
			"9.1": "n",
			"TP": "n"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n d #3",
			"23": "n d #3",
			"24": "n d #3",
			"25": "n d #3",
			"26": "n d #3",
			"27": "n d #3",
			"28": "n d #3",
			"29": "n d #3",
			"30": "n d #3",
			"31": "n d #3",
			"32": "n d #3",
			"33": "n d #3",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "n",
			"10": "n",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "n",
			"9.0-9.2": "n",
			"9.3": "n"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "y",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "n",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "y"
		},
		"and_ff": {
			"49": "y"
		},
		"ie_mob": {
			"10": "a #1",
			"11": "a #1"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "In Internet Explorer, the start and end values are not supported.",
		"2": "Enabled through the \"Enable Experimental Web Platform Features\" flag in chrome://flags",
		"3": "Enabled through the \"Enable Experimental Web Platform Features\" flag in opera://flags"
	},
	"usage_perc_y": 57.13,
	"usage_perc_a": 6.96,
	"ucprefix": false,
	"parent": "",
	"keywords": "text align last",
	"ie_id": "",
	"chrome_id": "",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-text-align-last.json
 ** module id = 434
 ** module chunks = 0
 **/